import { useState } from 'react';
import { faqItems } from '../../content/methodology';
import { FaqAccordion } from '../FaqAccordion';

export function FaqWithExpand() {
  const [expanded, setExpanded] = useState(false);
  const top6 = faqItems.filter((f) => f.priority === 'top6');
  const rest = faqItems.filter((f) => f.priority === 'extended');

  return (
    <section className="faq-with-expand">
      <h3>Nejčastější otázky</h3>
      <FaqAccordion items={top6} />
      {!expanded && (
        <button className="faq-with-expand__btn" onClick={() => setExpanded(true)}>
          Zobrazit všechny otázky (+{rest.length})
        </button>
      )}
      {expanded && (
        <>
          <hr className="faq-with-expand__divider" />
          <p className="faq-with-expand__more-label">Další otázky</p>
          <FaqAccordion items={rest} />
        </>
      )}
    </section>
  );
}
